export const ROUTES = {
  HOME: "/",
  LOGIN: (() => {
    const base = "/login";
    return {
      BASE: base,
      REDIRECT: (path: string, search: string) =>
        `${base}?redirect=${encodeURIComponent(path + search)}`,
    };
  })(),
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_OTP_VERIFICATION: (() => {
    const base = "/forgot-password-otp-verification";
    return {
      BASE: base,
      SENT_EMAIL: `${base}/email-sent`,
    };
  })(),
  CHANGE_PASSWORD: (() => {
    const base = "/changePassword";
    return {
      BASE: base,
      TOKEN: (token: string) => {
        return `${base}/${token}`;
      },
    };
  })(),
  COMMISSION_RULES: (() => {
    const base = "/commission-rules";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
        };
      },
    };
  })(),
  TARGET: (() => {
    const base = "/target";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
        };
      },
    };
  })(),
  TENANT_SUBSCRIPTIONS: (() => {
    const base = "/tenant-subscriptions";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
          VIEW: `${base}/view/${id}`,
        };
      },
    };
  })(),
  TENANT_TRANSACTIONS: (() => {
    const base = "/tenant-transactions";
    return {
      BASE: base,
    };
  })(),
  MESSAGE_CREDIT_CONFIGURATION: (() => {
    const base = "/message-credit-configuration";
    return {
      BASE: base,
    }
  })(),
  SETTINGS: (() => {
    const base = "/settings";
    return {
      BASE: base,
    };
  })(),

  PARTNER: (() => {
    const base = "/partners";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => ({
        BASE: `${base}/${id}`,
        VIEW: `${base}/view/${id}`,
      }),
      VIEW_USER_BY_ID: (partnerId: string, id: string) => ({
        BASE: `${base}/${partnerId}/viewuser/${id}`,
      }),
    };
  })(),
  PAYOUT_LOG: (() => {
    const base = "/payouts-logs";
    return {
      BASE: base,
    };
  })(),
  RUN_PAYOUT: (() => {
    const base = "/run-payout";
    return {
      BASE: base,
    };
  })(),
  PROFILE: (() => {
    const base = "/profile";
    return {
      BASE: base,
    };
  })(),
  COUPON: (() => {
    const base = "/coupon";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
        };
      },
    };
  })(),
  COUPON_USAGES: (() => {
    const base = "/coupon-usages";
    return {
      BASE: base,
    };
  })(),
  MODEL_WISE_CONFIGURATION: (() => {
    const base = "/model-wise-configuration";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
        };
      },
    };
  })(),
  PLAN: (() => {
    const base = "/plan";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => {
        return {
          BASE: `${base}/${id}`,
        };
      },
    };
  })(),
  EMAIL_CREDITS_CONFIGURATION: (() => {
    const base = "/email-credits-configuration";
    return {
      BASE: base,
    };
  })(),

  STORAGE_PRICE_CONFIGURATION: (() => {
    const base = "/storage-price-configuration";
    return {
      BASE: base,
    };
  })(),
  GOOGLE_ADS_CONFIGURATION: (() => {
    const base = "/google-ads-configuration";
    return {
      BASE: base,
    };
  })(),
  OFFLINE_REGISTRATION: (() => {
    const base = "/offline-registration";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => ({
        BASE: `${base}/${id}`,
      }),
    };
  })(),
  ROLESANDPERMISSIONS: (() => {
    const base = "/roles-and-permissions";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => ({
        BASE: `${base}/${id}`,
      }),
    };
  })(),
  USERS: (() => {
    const base = "/users";
    return {
      BASE: base,
      CREATE: `${base}/add`,
      ID: (id: string) => ({
        BASE: `${base}/${id}`,
      }),
    };
  })(),
  USERS_ACTIVITIES: (() => {
    const base = "/users-activities";
    return {
      BASE: base,
    };
  })(),
  TENANTS: (() => {
    const base = "/tenants";
    return {
      BASE: base,
    };
  })(),
  TENANT_IMPERSONATION_LOG: (() => {
    const base = "/tenant-impersonation-log";
    return {
      BASE: base,
    };
  })(),
  TICKETS: (() => {
    const base = "/tickets";
    return {
      BASE: base,
    };
  })(),
  SUPPORT_PHONE: (() => {
    const base = "/support-phone";
    return {
      BASE: base,
      CREATE: `${base}/create`,
      ID: (id: string) => ({
        BASE: `${base}/${id}`,
      }),
    };
  })(),
};